import * as types from "../../actions/section/types";
import { changeItemPosition } from "../../utils/positioning";

const initialState = {
  hasFetchError: false,
  isFetching: false,
  isLoaded: false,
  isMoving: false,
  list: [],
  page: 0,
  pageCount: 0,
  count: 0,
  savingId: null,
  successId: null,
};

export default function articles(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_SECTION_ARTICLES_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true,
        hasFetchError: false,
      });
    }
    case types.FETCH_SECTION_ARTICLES_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        hasFetchError: false,
        isLoaded: true,
        list: action.articles,
        page: action.page,
        pageCount: action.pageCount,
        count: action.count,
      });
    }
    case types.FETCH_SECTION_ARTICLES_FAILURE: {
      return Object.assign({}, state, {
        isFetching: false,
        isLoaded: false,
        hasFetchError: true,
      });
    }
    case types.MOVE_ARTICLE_TO_SECTION_REQUEST: {
      return Object.assign({}, state, {
        isMoving: true,
        list: state.list.filter(({ id }) => id !== action.movedArticleId),
      });
    }
    case types.MOVE_ARTICLE_TO_SECTION_FAILURE: {
      const newList = [...state.list];
      newList.splice(action.sourceIndex, 0, action.item);

      return Object.assign({}, state, {
        isMoving: false,
        list: newList,
      });
    }
    case types.MOVE_ARTICLE_TO_SECTION_SUCCESS: {
      return Object.assign({}, state, {
        isMoving: false,
      });
    }

    case types.POSITION_ARTICLE_REQUEST: {
      return Object.assign({}, state, {
        isMoving: true,
        savingId: state.list[action.sourceIndex].id,
        successId: null,
        list: changeItemPosition(
          state.list,
          action.sourceIndex,
          action.destinationIndex
        ),
      });
    }
    case types.POSITION_ARTICLE_FAILURE: {
      return Object.assign({}, state, {
        isMoving: false,
        savingId: null,
        successId: null,
        list: changeItemPosition(
          state.list,
          action.destinationIndex,
          action.sourceIndex
        ),
      });
    }
    case types.POSITION_ARTICLE_SUCCESS: {
      return Object.assign({}, state, {
        isMoving: false,
        savingId: null,
        successId: state.savingId,
      });
    }

    case types.MOVE_ARTICLE_TO_TOP_REQUEST: {
      const item = state.list[action.sourceIndex];
      return Object.assign({}, state, {
        isMoving: true,
        savingId: item.id,
        successId: null,
        list:
          state.page === 1
            ? changeItemPosition(state.list, action.sourceIndex, 0)
            : state.list.filter(article => article.id !== item.id),
      });
    }
    case types.MOVE_ARTICLE_TO_TOP_FAILURE: {
      let newList;

      if (state.page === 1) {
        newList = changeItemPosition(state.list, 0, action.sourceIndex);
      } else {
        newList = [...state.list];
        newList.splice(action.sourceIndex, 0, action.item);
      }

      return Object.assign({}, state, {
        isMoving: false,
        savingId: null,
        successId: null,
        list: newList,
      });
    }
    case types.MOVE_ARTICLE_TO_TOP_SUCCESS: {
      return Object.assign({}, state, {
        isMoving: false,
        savingId: null,
        successId: state.savingId,
      });
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/articles/index.js